import axios from 'axios'

// Get all for business
const getShows = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/show-validation/business`)
  return data
}

// Get messages from show
const getMessages = async (showDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/show-validation/${showDate}`)
  return data
}

// Create message
const create = async (showDate, message) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/show-validation`, {
    showDate,
    message
  })
  return data
}

const getAllShows = async (city = null, business = null, search = null) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/evento/search`, { city, business, search })
  return data
}

const getShowCaseShows = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/evento/showcase`)
  return data
}

const updateShowCase = async (shows) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/evento/showcase`, { shows })
  return data
}

// Approve show
const approve = async (showDate) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/show-validation/${showDate}`)
  return data
}

export {
  getShows,
  getMessages,
  getAllShows,
  getShowCaseShows,
  updateShowCase,
  create,
  approve
}
